import {APIURL} from '../../services/http/api';
import {HttpService} from '../../services/http/http.service';
import {EApiParams} from '../../services/http/apiParams.enum';
import {urlParamReplace} from '../../helpers/UrlParamReplace';

const http = new HttpService();

export const getSessionsUser = async (data: FormData, page: number) => {
  const api = APIURL.booking.getSessionsUser;
  const finalApi = urlParamReplace(api, {[EApiParams.page]: page});
  const [err, resp] = await http.post(finalApi, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return {error: err, response: resp?.data};
};
export const cancelSessions = async (data: FormData) => {
  const api = APIURL.booking.cancelSession;
  const [err, resp] = await http.post(api, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return {error: err, response: resp?.data};
};

export const addRating = async (data: FormData) => {
  const api = APIURL.booking.addRate;
  const [err, resp] = await http.post(api, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return {error: err, response: resp?.data};
};

export const submitSurvey = async (data: FormData) => {
  const api = APIURL.booking.submitSurvey;
  const [err, resp] = await http.post(api, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return {error: err, response: resp?.data};
};
